var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncementTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 51,
    viewBox: "0 0 63 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3076 23.779C40.1737 23.0555 41.0004 25.1879 42.8665 24.4644C44.7325 23.741 43.9058 21.6086 45.7719 20.8852C47.638 20.1617 48.4646 22.2941 50.3307 21.5706C52.1968 20.8472 51.3702 18.7148 53.2362 17.9914C55.1023 17.268 55.929 19.4003 57.7951 18.6769",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2363 19.7854C36.9441 18.7417 38.1367 20.6932 39.8444 19.6495C41.5521 18.6058 40.3595 16.6544 42.0673 15.6107C43.775 14.567 44.9676 16.5185 46.6753 15.4748C48.3831 14.4311 47.1905 12.4796 48.8982 11.436C50.6059 10.3923 51.7985 12.3437 53.5063 11.3",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5332 16.1661C33.9926 14.7964 35.5577 16.464 37.017 15.0942C38.4762 13.7246 36.9111 12.0571 38.3704 10.6874C39.8297 9.31765 41.3949 10.9852 42.8541 9.61548C44.3135 8.24577 42.7483 6.57826 44.2076 5.20857C45.6669 3.83888 47.232 5.50641 48.6914 4.13672",
    stroke: "#FFB858",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1328 13.3774C30.1328 13.3774 29.8745 16.848 33.131 21.7223C36.3874 26.5966 40.0135 28.2569 40.0135 28.2569L34.9253 31.6356L32.7412 33.0887L30.5855 34.5174L23.2313 39.401L20.2905 46.2327L4.69238 30.2711L30.1328 13.3774Z",
    fill: "#E6570E",
    stroke: "#E6570E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementTag);
export default __webpack_public_path__ + "static/media/announcement-tag.785752a9193ea431126d0005c0095453.svg";
export { ForwardRef as ReactComponent };